module.exports = __webpack_public_path__ + "img/adventureworld.0773e42b.png";